<script lang="ts">
    import { BodySmall, ColourVars, type Padding } from "component-lib";
    import type { Snippet } from "svelte";
    import ArrowLeft from "svelte-material-icons/ArrowLeft.svelte";
    import DotsVertical from "svelte-material-icons/DotsVertical.svelte";
    import Container from "./Container.svelte";
    import IconButton from "./buttons/IconButton.svelte";
    import MenuTrigger from "./menu/MenuTrigger.svelte";
    import Title from "./typography/Title.svelte";

    interface Props {
        onBack?: () => void;
        onAction?: () => void;
        title: Snippet;
        subtitle?: Snippet;
        menu?: Snippet;
        action?: Snippet<[string]>;
        avatar?: Snippet;
        onClick?: () => void;
        children?: Snippet;
    }

    let { onBack, onAction, title, subtitle, menu, action, avatar, onClick, children }: Props =
        $props();

    let padding = $derived<Padding>(["zero", "sm", "zero", onBack ? "zero" : "lg"]);
    let height = { size: "4rem" };
</script>

<Container
    {onClick}
    supplementalClass={"section_header"}
    {padding}
    {height}
    background={ColourVars.surface0}
    crossAxisAlignment={"center"}
    mainAxisAlignment={"spaceBetween"}
    gap={"sm"}>
    {#if onBack}
        <IconButton padding={["md", "zero", "md", "sm"]} size={"md"} onclick={onBack}>
            {#snippet icon(color)}
                <ArrowLeft {color} />
            {/snippet}
        </IconButton>
    {/if}

    <Container direction="horizontal" gap={"lg"} width={"fill"} crossAxisAlignment="center">
        {#if avatar}
            {@render avatar()}
        {/if}
        <Container gap={"xxs"} direction={"vertical"} width={"fill"}>
            <Title ellipsisTruncate fontWeight={"semi-bold"}>
                {@render title()}
            </Title>
            {#if subtitle !== undefined}
                <BodySmall colour={"textSecondary"} ellipsisTruncate fontWeight={"normal"}>
                    {@render subtitle()}
                </BodySmall>
            {/if}
        </Container>
    </Container>

    {#if action}
        <IconButton padding={["sm", "zero"]} size={"lg"} onclick={onAction}>
            {#snippet icon(color)}
                {@render action(color)}
            {/snippet}
        </IconButton>
    {/if}
    {@render children?.()}
    {#if menu}
        <MenuTrigger gutter={0} position={"bottom"} align={"end"}>
            <IconButton padding={["sm", "zero"]} size={"lg"}>
                {#snippet icon(color)}
                    <DotsVertical {color} />
                {/snippet}
            </IconButton>
            {#snippet menuItems()}
                {@render menu()}
            {/snippet}
        </MenuTrigger>
    {/if}
</Container>

<style lang="scss">
    :global(.container.section_header) {
        border-bottom: var(--bw-thick) solid var(--surface-1);
    }
</style>
